import { render, staticRenderFns } from "./CrazyExtrato.vue?vue&type=template&id=0ca52008&"
import script from "./CrazyExtrato.vue?vue&type=script&lang=js&"
export * from "./CrazyExtrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports